export default __webpack_public_path__ + "static/media/krystal1.435fe2af.png";